export const AMMINISTRAZIONE_TRASPARENTE_URL="/amministrazione-trasparente"
export const MODELLO_ORGANIZZATIVO_DI_GESTIONE_E_CONTROLLO="/modello-organizzativo-di-gestione-e-controllo"